import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function DownloadIcon(props: ACIconProps) {
  return <ACIconWrapper component={DownloadSvg} {...props} />;
}

const DownloadSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 6.75C5 5.23122 6.23122 4 7.75 4H12.75C12.9489 4 13.1397 4.07902 13.2803 4.21967L18.7803 9.71967C18.921 9.86032 19 10.0511 19 10.25V17.25C19 18.7688 17.7688 20 16.25 20H15.75C15.3358 20 15 19.6642 15 19.25C15 18.8358 15.3358 18.5 15.75 18.5H16.25C16.9404 18.5 17.5 17.9404 17.5 17.25V11H14.75C13.2312 11 12 9.76878 12 8.25V5.5H7.75C7.05964 5.5 6.5 6.05964 6.5 6.75V17.25C6.5 17.9404 7.05964 18.5 7.75 18.5H8.25C8.66421 18.5 9 18.8358 9 19.25C9 19.6642 8.66421 20 8.25 20H7.75C6.23122 20 5 18.7688 5 17.25V6.75ZM13.5 6.56066L16.4393 9.5H14.75C14.0596 9.5 13.5 8.94036 13.5 8.25V6.56066Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 13C12.4142 13 12.75 13.3358 12.75 13.75V19.25C12.75 19.6642 12.4142 20 12 20C11.5858 20 11.25 19.6642 11.25 19.25V13.75C11.25 13.3358 11.5858 13 12 13Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.24828 16.1925C9.55616 15.9154 10.0304 15.9404 10.3075 16.2483L12 18.1289L13.6925 16.2483C13.9696 15.9404 14.4438 15.9154 14.7517 16.1925C15.0596 16.4696 15.0846 16.9438 14.8075 17.2517L12.5575 19.7517C12.4152 19.9098 12.2126 20 12 20C11.7874 20 11.5848 19.9098 11.4425 19.7517L9.19253 17.2517C8.91543 16.9438 8.94039 16.4696 9.24828 16.1925Z"
        fill="currentColor"
      />
    </svg>
  );
};
